import React from "react";
import { Link } from "react-router-dom";
import { routesApp } from "../router/interfaces";
import "./styles_02.css";

export const Contact = (props) => {
  return (
    <div className="root_18">
      <div id="contact">
        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <div
                style={{
                  paddingTop: props.mt ? "25px" : "",
                }}
                className="containerInfo_90"
              >
                {/* <div className="boxInfo1">
                  <p>
                    Email:{" "}
                    <span>
                      <a href="mailto:contact@rewireholding.com">
                        contact@icredit.com
                      </a>
                    </span>
                  </p>
                </div> */}
                <div className="boxInfo1">
                  <Link to={routesApp?.terms_conditions}>
                    Terms and Conditions
                  </Link>

                  <Link to={routesApp?.privacy}>Privacy Policy</Link>
                </div>
                <div className="boxInfo2">
                  <span>Copyright 2025,Icredit (PTY) Ltd</span>
                </div>
              </div>
              <div className="social social_02"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
